import React from 'react';
export function TrustBar() {
  return <div className="sticky top-0 z-50 w-full bg-[#5C1A1B] border-b border-white/10 py-2.5 px-4" data-id="element-313">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-[11px] sm:text-xs font-inter font-medium text-white" data-id="element-314">
        <div className="flex items-center gap-1.5" data-id="element-315">
          <span data-id="element-316">🔮</span>
          <span data-id="element-317">+10 Años de Experiencia</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-318">
          <span data-id="element-319">⭐️</span>
          <span data-id="element-320">4.9/5 de Calificación (847+ Reseñas)</span>
        </div>
      </div>
    </div>;
}